<script lang="ts">
	export let images: string[] = [];
	export let alts: string[] = [];
	export let cols: number = 3;
</script>

<div class="w-full h-fit grid grid-cols-{cols} gap-[6px] auto-rows-min">
	{#each Array(cols) as _, colIndex}
		<div class="flex flex-col gap-[1px]">
			{#each images.filter((_, i) => i % cols === colIndex) as img, i}
				<img src={img} alt={alts[i] || 'Gallery image'} class="w-full rounded" loading="lazy" />
				<div class="h-1"></div>
			{/each}
		</div>
	{/each}
</div>
